var $4e6cde11c2bc9840$exports = {};
$4e6cde11c2bc9840$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "Kr\u0101su atlas\u012Bt\u0101js",
  "colorSwatch": "kr\u0101su paraugs",
  "transparent": "caursp\u012Bd\u012Bgs",
  "twoDimensionalSlider": "2D sl\u012Bdnis"
};
export { $4e6cde11c2bc9840$exports as default };